module.exports = __webpack_public_path__ + "img/4@2x (2).414abc3c.png";